import { render, staticRenderFns } from "./OrderFormTabs.vue?vue&type=template&id=be7928d8&scoped=true"
import script from "./OrderFormTabs.vue?vue&type=script&lang=js"
export * from "./OrderFormTabs.vue?vue&type=script&lang=js"
import style0 from "./OrderFormTabs.vue?vue&type=style&index=0&id=be7928d8&prod&lang=scss&scoped=true"
import style1 from "./OrderFormTabs.vue?vue&type=style&index=1&id=be7928d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7928d8",
  null
  
)

export default component.exports